export enum WayToParticipate {
  JOIN_TEAM = 'join_team',
  CREATE_TEAM = 'create_team',
  WALK_AS_INDIVIDUAL = 'walk',
}
